import verified from "#/assets/badge/verified-badge.svg";
import type { Consultant } from "@/types/consulting";
import ExtendedImage from "../ui/extended-image";
import ExpertDialog from "./expert-dialog";

interface ExpertCardProps {
  expert: Consultant;
  consultingProjectId: string;
  consultingExpertiseId: string | null;
  consultingCityId: string | null;
}

const ExpertCard = ({
  expert,
  consultingProjectId,
  consultingExpertiseId,
  consultingCityId,
}: ExpertCardProps) => {
  return (
    <ExpertDialog
      consultingCityId={consultingCityId}
      consultingExpertiseId={consultingExpertiseId}
      consultingProjectId={consultingProjectId}
      expert={expert}
    >
      <div
        className="border rounded-2xl p-2 w-44 flex flex-col gap-2 border-gray-300 hover:border-brand-blue-600 hover:bg-brand-blue-100 cursor-pointer"
        key={expert.id}
      >
        <ExtendedImage
          alt={expert.name}
          className="rounded-xl size-44 aspect-square grow-0 object-cover"
          height={176}
          src={expert.imageUrl}
          width={176}
        />
        <div className="text-[12px] leading-4.5 font-semibold">
          <h3 className="inline-flex justify-center items-center gap-1">
            {expert.name}
            <ExtendedImage
              alt="verified user"
              height={16}
              src={verified}
              width={16}
            />
          </h3>
          <h3 className="font-medium opacity-90">{expert.expertises.at(0)}</h3>
        </div>
        <p className="text-[12px] leading-4.5 font-medium line-clamp-4">
          {expert.bio}
        </p>
      </div>
    </ExpertDialog>
  );
};

export default ExpertCard;
